import React, { useEffect } from "react";
import { Button, Form, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getHealthProduct } from "../../../Redux/actions/getHealthProduct";

const HealthFormOne = ({
  onFinishFailed,
  onFinishStep1,
  form,
  productHeading,
}) => {
  const { Option } = Select;
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.getHealthProduct);

  useEffect(() => {
    dispatch(getHealthProduct());
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      const matchedProduct = data.find(
        (item) => item.Product_Name == productHeading
      );

      if (matchedProduct) {
        form.setFieldsValue({ Product_ID: matchedProduct.Product_ID });
      }
    }
  }, [data, productHeading]);

  return (
    <div
      className="col-sm-8 mForm"
      style={{ backgroundColor: "rgb(15 181 131 / 69%)" }}>
      <div className="centreWidthFOrm">
        <h3 className="cnhbsh3">Salaam Health Takaful</h3>
        <h5 className="cnhbsh5">Basic Information</h5>
        <Form
          name="sehatFormOne"
          onFinish={onFinishStep1}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
          layout="vertical"
        >
          <div className="row">
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Name"
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Name is required!",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Please enter a valid email!",
                  },
                  {
                    required: true,
                    message: "Email is required!",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Contact"
                label="Contact"
                rules={[
                  {
                    required: true,
                    pattern: /^03\d{2}-\d{7}$/,
                    message:
                      "Contact number must be in this format 03XX-XXXXXXX",
                  },
                ]}
                normalize={(value) => {
                  if (!value) {
                    return value;
                  }
                  const onlyNums = value.replace(/[^\d]/g, "");
                  if (onlyNums.length <= 4) {
                    return onlyNums;
                  } else if (onlyNums.length <= 11) {
                    return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 11)}`;
                  }
                  return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 11)}`;
                }}
              >
                <Input placeholder="Contact 03XX-XXXXXXX" />
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Product_ID"
                label="Products"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Products">
                  {data.map((item, i) => (
                    <Option value={item.Product_ID}>{item.Product_Name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            
            <div className="col-sm-12">
              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ background: "#1C75BC" }}>
                  Next
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default HealthFormOne;
